/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../../components/FinalForms/FormCreator";
import UploadResumeCandidateFields from "../component/UploadResumeCandidate.Data";
import Buttons from "../../../../../components/ui/button/Buttons";
import { AppIcons } from "../../../../../data/appIcons";
import { useUploadResumeCandidateMutation } from "../../../../../app/services/candidateAPI";
import ToastService from "../../../../../services/toastService/ToastService";


const initState = {
  File: ""
};

const UploadResumeCandidate = (props) => {

  const uploadResumeCandidateRef = useRef();

  const [uploadResumeCandidateForm, setUploadResumeCandidateForm] = useState(UploadResumeCandidateFields);

  const [
    uploadResumeCandidate,
    {
      isSuccess: isUploadResumeCandidateAdded,
      isLoading: isUploadResumeCandidateAdding,
      data: addUploadResumeCandidateData,
    },
  ] = useUploadResumeCandidateMutation();



  const handleAddClick = () => {

    const candidateFormData = uploadResumeCandidateRef.current.getFormData();
    if (candidateFormData) {
      const requestData = {
        base64File: candidateFormData.File.base64Data,
        candidateResume: candidateFormData.File.fileName,
        storagePath: "document"
      };

      uploadResumeCandidate(requestData);
    }
  };


  useEffect(() => {
    if (isUploadResumeCandidateAdded && addUploadResumeCandidateData) {
      if (addUploadResumeCandidateData.message && addUploadResumeCandidateData.message.includes("mismatch")) {
        ToastService.warning(addUploadResumeCandidateData.message);
      }
      else {

        ToastService.success(addUploadResumeCandidateData.errorMessage);
      }
      resetForm();
      props.handleToggleModal();
    }
  }, [isUploadResumeCandidateAdded, addUploadResumeCandidateData]);

  const resetForm = () => {
    const formData = { ...uploadResumeCandidateForm };
    formData.initialState = { ...initState };
    setUploadResumeCandidateForm(formData);
  };

  return (
    <div className="import-candidate-sec">
      <div className="notes-sec">
        <p>
          <b>Note :</b> Upload .pdf Only
        </p>
      </div>
      <FormCreator
        config={uploadResumeCandidateForm}
        ref={uploadResumeCandidateRef}
        {...uploadResumeCandidateForm}></FormCreator>
      <div className="form-btn d-flex align-items-center justify-content-end mt-4 mb-2">

        <div className="d-flex align-items-center">
          <Buttons
            buttonTypeClassName="dark-btn"
            onClick={props.handleToggleModal}
            buttonText="Cancel" />
          <Buttons
            textWithIcon={false}
            imagePath={AppIcons.ImportIcon}
            buttonTypeClassName="theme-btn ml-5"
            onClick={handleAddClick}
            buttonText="Upload Candidate Resume"
            isLoading={isUploadResumeCandidateAdding}
          />
        </div>
      </div>
    </div>
  );
};

export default UploadResumeCandidate;
